export const isCardNumberValueValidate = (value) => {
  return !Number.isInteger(Number(value.replaceAll(' ', '')));
};
